export enum PGBossJobState {
  CREATED = 'created',
  RETRY = 'retry',
  ACTIVE = 'active',
  COMPLETED = 'completed',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
  FAILED = 'failed',
}

export type PGBossJobStateType = keyof typeof PGBossJobState
